export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/banner-layer.ec40270f-c8f1c4.png";